// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"14":"tv","137":"screens","177":"home","278":"screen-1","328":"admin","934":"screen-2"}[chunkId] + "." + {"14":"a57ea5d9","137":"47963730","177":"aced25e4","278":"36a74945","328":"5a4bece4","934":"a4138f77"}[chunkId] + ".js";
};